// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"888":"a55727bd","914":"d93376a8"}[chunkId] + ".css";
};